import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
//const baseURL = 'http://rutasmeigasservices.test/api/v1';
const baseURL = 'https://rutasmeigasservices.alvapy.com/api/v1';

axios.defaults.baseURL = baseURL;
Vue.use(VueAxios, axios);